import React, { useState, useEffect } from 'react';
import {
  Container, Grid, Paper, Typography, List, ListItem, ListItemIcon, ListItemText, Box, Stack, Fade,
  Slide, IconButton, Button
} from '@mui/material';
import {
  School,
  BuildCircle,
  BusinessCenter,
  Factory,
  Work,
  AccountBalance,
  Timeline, WorkOutline, Star, MonetizationOn, AccessTime, Event
} from '@mui/icons-material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import StudentChapterComponent from '../../components/studentchapter';
import { Icon } from 'lucide-react';
const HeroBanner = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: { xs: '60vh', md: '80vh' },  // Responsive height
        backgroundImage: 'url(/img-1.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        color: 'white',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0, 0, 0, 0.5)',  // Dark overlay for better text visibility
        }
      }}
    >
      <Container sx={{ position: 'relative', zIndex: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
          Empowering Students for a Brighter Future
        </Typography>
        <Typography variant="h6" sx={{ mb: 4 }}>
          Join our training program and explore new career opportunities.
        </Typography>
        {/* <Button variant="contained" color="primary" size="large">
                        Get Started
                    </Button> */}
      </Container>
    </Box>
  );
};
const AnimatedSection = ({ title, subtitle, content, imageSrc, reverse, bgGradient, children }) => (
  <Box
    className={`py-20 w-full ${bgGradient} relative overflow-hidden`}
    sx={{
      // '&::before': {
      //   content: '""',
      //   position: 'absolute',
      //   top: 0,
      //   left: 0,
      //   right: 0,
      //   bottom: 0,
      //   background: 'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)',
      //   animation: 'pulse 3s infinite',

      // },
      mt: "20px",
      mb: "40px",
      '@keyframes pulse': {
        '0%': { opacity: 0.5 },
        '50%': { opacity: 1 },
        '100%': { opacity: 0.5 }
      }
    }}
  >
    <Container maxWidth="lg">
      <Grid
        container
        spacing={8}
        direction={reverse ? 'row-reverse' : 'row'}
        alignItems="center"
      >
        <Grid item xs={12} md={6}>
          <Box className="transform transition-all duration-700 hover:translate-y-[-8px]">
            {/* <Typography 
                    variant="h6" 
                    className="mb-2 text-white/80 font-light tracking-wider uppercase"
                    sx={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}
                  >
                    {subtitle}
                  </Typography> */}
            <Typography
              variant="h2"
              className="mb-8 font-bold bg-gradient-to-r from-white to-white/80 bg-clip-text"
              sx={{
                textShadow: '0 2px 4px rgba(0,0,0,0.2)',
                fontWeight: 800,
                letterSpacing: '-0.02em'
              }}
            >
              {title}
            </Typography>
            <Box className="relative">
              {content}
              {children}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            className="rounded-2xl overflow-hidden shadow-2xl transform transition-all duration-700 hover:scale-105 hover:rotate-1"
            sx={{
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
                transition: 'all 0.3s ease'
              },
              '&:hover::after': {
                opacity: 0
              }
            }}
          >
            <img
              src={imageSrc || "/api/placeholder/600/400"}
              alt={title}
              className="w-full h-full object-cover"
              style={{ height: "auto", maxWidth: "100%" }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

const StudentChapter = () => {
  const features = [
    'Masters Training Program',
    'Service Sector Opportunities',
    'Selling and Marketing Sector Training',
    'Learning with Earning Opportunity',
    'Digital Enrollment Process',
    'Refundable Deposit: ₹2,000'
  ];
  // Example usage for Auro University
  // const auroChapterData = {
  //   collegeName: "Auro University, Surat",
  //   collegeImage: "/Dashboard/auro-university.jpeg",
  //   totalMembers: 45,
  //   leadership: [
  //     {
  //       name: "John Doe",
  //       position: "Chapter President",
  //       department: "Mechanical Engineering",
  //       image: "/path-to-president-image.jpg"
  //     },
  //     {
  //       name: "Jane Smith",
  //       position: "Vice President",
  //       department: "Computer Science",
  //       image: "/path-to-vp-image.jpg"
  //     }
  //   ],
  //   sectorDistribution: [
  //     { name: "Service Sector", count: 15 },
  //     { name: "Manufacturing Sector", count: 20 },
  //     { name: "Industrial Sector", count: 10 }
  //   ],
  //   eventPhotos: [
  //     { url: "/Events/img-19.jpg", caption: "IPR Seminar on 27th January 2025" },
  //     // Add more photos as needed
  //   ],
  //   // additionalContent: <YourCustomComponent /> // Optional
  // };

  const governmentEngineeringData = {
    collegeName: "Government Engineering College, Surat",
    collegeImage: "/Dashboard/governemnt-college-surat.jpg",
    totalMembers: 60,
    leadership: [
      {
        name: "Rahul Sharma",
        position: "Chapter President",
        department: "Electrical Engineering",
        image: "/path-to-president-image.jpg"
      },
      {
        name: "Ananya Patel",
        position: "Vice President",
        department: "Information Technology",
        image: "/path-to-vp-image.jpg"
      }
    ],
    sectorDistribution: [
      { name: "Service Sector", count: 18 },
      { name: "Manufacturing Sector", count: 25 },
      { name: "Industrial Sector", count: 17 }
    ],
    eventPhotos: [
      { url: "/Events/img-15.jpg", caption: "IPR Seminar on 27th Januray 2025" },
      // Add more photos as needed
    ],
    // additionalContent: <YourCustomComponent /> // Optional
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
  }, []);
  return (
    <>
      <HeroBanner />
      <AnimatedSection
        title="Program Features"
        subtitle="What We Offer"
        bgGradient="bg-gradient-to-r from-blue-600 to-blue-900"
        imageSrc="/img-1.jpg"
        content={
          <List className="space-y-4">
            {features.map((item, index) => (
              <ListItem
                key={index}
                className="transform transition-all duration-500 hover:translate-x-4 bg-white/10 backdrop-blur-lg rounded-xl p-4"
              >
                <ListItemIcon>
                  <Star className="text-yellow-400" />
                </ListItemIcon>
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    className: "text-xl font-medium text-white"
                  }}
                />
              </ListItem>
            ))}
          </List>
        }
      />

      <AnimatedSection
        title="How to Enroll"
        subtitle="Join Our Program"
        bgGradient="bg-gradient-to-r from-purple-600 to-purple-900"
        reverse={true}
        imageSrc="/img-2.jpg"
        content={
          <Box className="space-y-8">
            <Typography
              sx={{ paddingY: 2 }}
              className="transform transition-all duration-500 hover:translate-x-2"
            >
              Complete online registration through our Google form and submit a refundable deposit of ₹2,000 as per NYCS norms.
            </Typography>



            <Box className="bg-white/10 backdrop-blur-lg rounded-2xl p-6">
              <Typography variant="h4" className="mb-6 text-white font-bold">
                Refund Policy
              </Typography>
              <List className="space-y-4">
                {[
                  '100% refund if NYCS fails to offer an opportunity',
                  '90% refund if you don\'t join after receiving an offer',
                  '100% refund upon completion of the LWE Schedule'
                ].map((text, index) => (
                  <ListItem
                    key={index}
                    className="transform transition-all duration-500 hover:translate-x-2"
                  >
                    <ListItemIcon>
                      <AccountBalance className="text-yellow-400" />
                    </ListItemIcon>
                    <ListItemText
                      primary={text}
                      primaryTypographyProps={{
                        className: "text-white/90"
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>
        }
      />

      <AnimatedSection
        title="Projected Earnings"
        subtitle="Your Growth"
        bgGradient="bg-gradient-to-r from-emerald-600 to-emerald-900"
        imageSrc="/Yuva-5.png"
      >



        <Grid container spacing={3} justifyContent="center" >
          {[
            { icon: <CurrencyRupeeIcon fontSize="large" />, amount: '₹2,000', label: 'Monthly Earnings' },
            { icon: <AccessTime fontSize="large" />, amount: '2 Hours', label: 'Daily Commitment' },
            { icon: <Event fontSize="large" />, amount: '20 Days', label: 'Monthly Working Days' }
          ].map((item, index) => (
            <Grid item xs={12} sm={4} key={index} mt={5}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box sx={{ color: '#000', fontSize: 40, mb: 1 }}>
                  {item.icon}
                </Box>
                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
                  {item.amount}
                </Typography>
                <Typography variant="body2" sx={{ color: '#777' }}>
                  {item.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>




      </AnimatedSection>

      <AnimatedSection
        title="Available Job Profiles"
        subtitle="Career Paths"
        bgGradient="bg-gradient-to-r from-rose-600 to-rose-900"
        reverse={true}
        imageSrc="/savings-1.jpg"
      >
        <Grid container spacing={4} marginTop="0px" mb={5}>
          {[
            {
              icon: <BuildCircle fontSize="large" className="text-yellow-400" sx={{ marginRight: "20px", }} />,
              title: 'Service Sector',
              content: 'Automobile, Two-wheeler Service, Housekeeping etc.',
            },
            {
              icon: <BusinessCenter fontSize="large" className="text-blue-400" sx={{ marginRight: "20px" }} />,
              title: 'Industrial Sector',
              content: 'Account audit training and material reconciliation',
            },
            {
              icon: <Factory fontSize="large" className="text-green-400" sx={{ marginRight: "20px" }} />,
              title: 'Manufacturing Sector',
              content: 'Cottage-micro small industries',
            },
          ].map((section, index) => (
            <Grid item xs={12} key={index}>
              <Paper
                elevation={0}
                className="p-6 transform transition-all duration-500 hover:scale-105 bg-white/10 backdrop-blur-lg rounded-2xl"
              >
                <Box sx={{ display: "flex", flexDirection: "row" }}>

                  {section.icon}
                  <Typography variant="h4" className="font-bold mb-3 text-white flex items-center gap-2">
                    {section.title}
                  </Typography>
                </Box>

                <Typography variant="body1" className="text-white/80 text-lg" sx={{ marginLeft: "60px" }}>
                  <li>{section.content}</li>
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

      </AnimatedSection>

      {/* <Typography variant="h4" align="center" gutterBottom>
        Auro University Student Chapter
      </Typography> */}
      {/* <StudentChapterComponent {...auroChapterData} /> */}

      <Typography variant="h4" align="center" gutterBottom sx={{ mt: 4 }}>
        Government Engineering College Surat Student Chapter
      </Typography>
      <StudentChapterComponent {...governmentEngineeringData} />

    </>
    //           <Box className="bg-gradient-to-b from-gray-900 to-black min-h-screen">
    //             <HeroBanner />


    //           </Box>
  );
};

export default StudentChapter;
